import { useTranslation } from "react-i18next";
import { useStartupParamsStore } from "@/store/startupParams";

export const useServiceT = () => {
  const { t } = useTranslation();
  const serviceType = useStartupParamsStore((state) => state.serviceType);

  return (key: string, options?: object) =>
    t([`${key}:${serviceType}`, key], options);
};
